export const showCamera = state => {
    return toggleCamera(state, true);
};

export const hideCamera = state => {
    return toggleCamera(state, false);
};

const toggleCamera = (state, value) => {
    return {
        ...state,
        questionSet: {
            ...state.questionSet,
            questionSet: {
                ...state.questionSet.questionSet,
                cameraVisible: value
            }
        }
    };
};

export const showRecorder = state => {
    return toggleAudioRecorder(state, true);
};

export const hideRecorder = state => {
    return toggleAudioRecorder(state, false);
};

const toggleAudioRecorder = (state, value) => {
    return {
        ...state,
        questionSet: {
            ...state.questionSet,
            questionSet: {
                ...state.questionSet.questionSet,
                audioRecorderVisible: value
            }
        }
    };
};
